export default __webpack_public_path__ + "static/media/pendCrianca.614010b8.svg";